import TrustBadges from "./TrustBadges";
import { stockAvailability } from "../utils/stockAvailability";

function ListingCard({ favoriteActionListingId, listing, onOpen, onToggleFavorite, showTradeDetails = false, onProposeTrade }) {
  const availability = stockAvailability(listing.inventoryCount);
  const canFavorite = onToggleFavorite && !listing.isOwner;
  return (
    <article className={`listing-card ${canFavorite ? "has-favorite" : ""}`} onClick={() => onOpen?.(listing)}>
      {listing.image ? (
        <img src={listing.image} alt="" />
      ) : (
        <div className="listing-image-placeholder">Intet billede</div>
      )}
      <div className="listing-body">
        <div>
          <h3><button className="listing-title-button" type="button" aria-label={`Se ${listing.title}`} onClick={event => { event.stopPropagation(); onOpen?.(listing); }}>{listing.title}</button></h3>
          <p>
            {listing.location} | {listing.category}
          </p>
          <p className="seller-line">
            {listing.seller} | {formatRating(listing)}
          </p>
          <TrustBadges
            compact
            completedSalesCount={listing.completedSalesCount}
            ratingAverage={listing.ratingAverage}
            ratingCount={listing.ratingCount}
            verified={listing.verified}
          />
        </div>
        <div className="listing-meta">
          <strong>{listing.price}</strong>
          {listing.tradeMode === "both" && <span className="trade-badge">⇄ Kan også byttes</span>}
          {availability && <span className={`stock-label ${availability.level}`}>{availability.label}</span>}
        </div>
        {showTradeDetails && <div className="listing-trade-details">
          <div className="trade-wishes"><small>Ønsker at bytte til</small><strong>{listing.tradeWishes || "Åben for forslag"}</strong></div>
          {listing.isOwner ? <span className="listing-owner-label">Din annonce</span> : <button className="secondary-action" type="button" onClick={event => { event.stopPropagation(); onProposeTrade?.(listing); }}>Foreslå bytte <span aria-hidden="true">⇄</span></button>}
        </div>}
      </div>
      {canFavorite && (
        <button
          aria-label={listing.isFavorite ? "Fjern fra favoritter" : "Gem som favorit"}
          aria-pressed={Boolean(listing.isFavorite)}
          className={`favorite-button ${listing.isFavorite ? "active" : ""}`}
          disabled={favoriteActionListingId === listing.id}
          onClick={(event) => {
            event.stopPropagation();
            onToggleFavorite(listing);
          }}
          type="button"
        >
          {listing.isFavorite ? "♥" : "♡"}
        </button>
      )}
      {listing.hasMatchScore && <div className="match-badge">{listing.score}</div>}
    </article>
  );
}

function formatRating(listing) {
  if (!listing.ratingCount) {
    return "Ingen rating endnu";
  }

  return `${listing.ratingAverage.toFixed(1)} rating (${listing.ratingCount})`;
}

export default ListingCard;
